import ReportDocument from "./report-document";
export default ReportDocument;
